/**
 * Scroll container for the alert detail pane (header, clip, verdict buttons,
 * history table).
 *
 * `scrollbar-gutter: stable` is load-bearing, not cosmetic. The clip's width is
 * measured from inside this container with a ResizeObserver and its height is
 * derived from that width, so the pane's content height depends on the pane's
 * width. With a classic (layout-consuming) scrollbar — Windows, or macOS with
 * a mouse / "Always show scroll bars" — and content within one scrollbar's
 * worth of fitting, the scrollbar appearing shrank the clip enough to make the
 * content fit, which removed the scrollbar, which widened the clip again…
 * flipping between the two layouts on every frame (SUP-581, SUP-582; 5.3.11).
 * Reserving the gutter permanently means the scrollbar never changes the
 * measured width, so the loop cannot start.
 */
export const ALERTS_DETAIL_PANE_SCROLLBAR_GUTTER_CLASS =
  "[scrollbar-gutter:stable]";

export const alertsDetailPaneScrollClassName = `min-h-0 min-w-0 max-w-full overflow-y-auto ${ALERTS_DETAIL_PANE_SCROLLBAR_GUTTER_CLASS} pt-[10px] pb-2`;
